class DownloadableConfigs {
    constructor() {
        this.checkParameterAction();
    }
    checkParameterAction(){
        let redirect = new URLSearchParams(window.location.search).get('redirect');
        if(redirect !==  null){
            $.ajax({
                url: '?do=isConfigDownloadable',
                type: 'GET',
                dataType: '',
                data: { organizationID: new URLSearchParams(window.location.search).get('organizationID')}
            }).done(function(data) {
                if(data['is_downloadable']){
                    var link = document.createElement("a");
                    link.download = name;
                    link.href = redirect;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            });
        }
    }
}
window.DownloadableConfigs = DownloadableConfigs;